import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "popover"];

  toggle(event) {
    event.preventDefault();
    this.isOpen() ? this.close() : this.open();
  }

  open() {
    this.popoverTarget.removeAttribute("hidden");
    this.buttonTarget.setAttribute("aria-expanded", "true");
    document.addEventListener("click", this.outsideClick);
  }

  close() {
    this.popoverTarget.setAttribute("hidden", "");
    this.buttonTarget.setAttribute("aria-expanded", "false");
    document.removeEventListener("click", this.outsideClick);
  }

  isOpen() {
    return !this.popoverTarget.hasAttribute("hidden");
  }

  outsideClick = (event) => {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }
}
